<template>
  <div>
    <div class="table-panel flex flex-start item-center p20 bgColor">
      <el-radio-group v-model="radioType" size="small" @change="switchTab">
        <el-radio-button label="manage">关联商品管理</el-radio-button>
        <el-radio-button label="detail">关联商品详情</el-radio-button>
      </el-radio-group>
    </div>
    <hm-content title="关联商品管理" v-if="radioType === 'manage'">
      <div class="button-panel flex flex-end item-center">
        <el-button
            type="primary"
            size="small"
            class="add-btn"
            @click="radioType = 'detail'"
        >新增关联组</el-button
        >
          <el-input
              clearable
              style="width: 300px"
              v-model.trim="relName"
              placeholder="请输入关联组名称"
              size="small"
              class="ipt mr10"
          ></el-input>
          <el-button size="small" type="primary" @click="search">查询</el-button>

        <el-button type="primary" size="small" @click="outputExcel"
        >导出模板</el-button
        >
        <div
            class="
            pointer
            mr10
            open-file
            el-button--primary
            el-button el-button--small
          "
        >
          导入
          <input
              type="file"
              @change="importf"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
      </div>
      <div class="inputDeep">
        <el-table :data="tableData" stripe style="width: 100%">
          <div slot="empty" style="margin-top: 118px">
            <div class="hmicon icon-a-zanwushuju2x"></div>
            <div>暂无数据</div>
          </div>
          <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="relationCode"
              label="关联码"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="relationName"
              label="关联组名称"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="updateTime"
              label="更新时间"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="goodsSn"
              label="操作"
          >
            <template slot-scope="scope">
              <el-button
                  @click="edit(scope.row, scope.$index)"
                  size="small"
                  class="blue"
                  type="text"
              >商品操作</el-button
              >
              <span> | </span>
              <el-button
                  @click="deleteAgent(scope.row)"
                  size="small"
                  class="danger"
                  type="text"
              >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
        ></el-pagination>
      </div>
    </hm-content>
    <hm-content title="关联商品详情" v-else>
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-width="100px"
      >
        <el-form-item label="关联码" prop="relationCode">
          <el-input
              v-model.trim="ruleForm.relationCode"
              maxlength="20"
              size="small"
              placeholder="请输入关联码"
          ></el-input>
        </el-form-item>
        <el-form-item label="关联组名称" prop="relationName">
          <el-input
              v-model.trim="ruleForm.relationName"
              maxlength="20"
              size="small"
              placeholder="请输入关联组名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="goods-btn-wapper flex flex-end item-center mt20 mb20">
        <el-button
            type="primary"
            size="small"
            class="add-goods-btn"
            @click="addGoods"
        >添加商品</el-button
        >
      </div>
      <div class="inputDeep m20">
        <el-table :data="tableData2" stripe style="width: 100%">
          <div slot="empty" style="margin-top: 118px">
            <div class="hmicon icon-a-zanwushuju2x"></div>
            <div>暂无数据</div>
          </div>
          <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="wxshopSpuName"
              label="商品名称"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="goodsSn"
              label="商品货号"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="brandName"
              label="品牌"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              label="排序"
              prop="seqNum"
          >
            <template slot-scope="scope">
              <div @dblclick="changeEnddate(scope.$index, scope.row)">
                <el-tooltip
                    class="item"
                    effect="dark"
                    content="双击修改"
                    placement="top"
                    :disabled="scope.row.edit_enddate"
                >
                <span v-show="scope.row.edit_enddate" class="blue">{{
                    scope.row.seqNum
                  }}</span>
                </el-tooltip>
                <el-input
                    type="number"
                    :ref="'enddateinput' + scope.$index"
                    @blur="enddateblur(scope.$index, scope.row)"
                    @keyup.enter.native="$event.target.blur"
                    clearable
                    v-show="!scope.row.edit_enddate"
                    size="mini"
                    style="width: 100%"
                    v-model="scope.row.seqNum"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="wxshopNickName"
              label="简称"
          >
          <template slot-scope="scope">
              <div @dblclick="changeEnddate3(scope.$index, scope.row)">
                <el-tooltip
                    class="item"
                    effect="dark"
                    content="双击修改"
                    placement="top"
                    :disabled="scope.row.edit_wxshopNickName"
                >
                <span v-show="scope.row.edit_wxshopNickName" class="blue">{{
                    scope.row.wxshopNickName
                  }}</span>
                </el-tooltip>
                <el-input
                    type="text"
                    :ref="'enddateinput3' + scope.$index"
                    @blur="enddateblur3(scope.$index, scope.row)"
                    @keyup.enter.native="$event.target.blur"
                    clearable
                    v-show="!scope.row.edit_wxshopNickName"
                    size="mini"
                    style="width: 100%"
                    maxLength="20"
                    v-model="scope.row.wxshopNickName"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                  @click="table2RowDel(scope.$index, scope.row)"
                  size="small"
                  class="danger"
                  type="text"
              >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="bottom-btn-group flex flex-center item-center mt20">
        <el-button type="primary" size="small" @click="relCreate"
        >保存</el-button
        >
        <el-button type="info" size="small" @click="addCancel">取消</el-button>
      </div>
    </hm-content>
    <!-- 商品操作弹窗 -->
    <el-dialog
        width="1200px"
        title="请选择微店商品"
        :visible="operateDialogVisible"
        @close="operateDialogVisible = false"
    >
      <div class="top-btn-wrapper flex flex-end">
        <el-button
            type="primary"
            size="small"
            style="margin-right: auto"
            @click="addGoods"
        >追加商品</el-button
        >
        <el-select
            v-model="searchCondition.spuType"
            filterable
            placeholder="请选择微店商品分类"
            size="small"
            clearable
            class="mr10"
            @change="search1"
        >
          <el-option label="实物" value="reality"></el-option>
          <el-option label="虚拟" value="virtual"></el-option>
        </el-select>
        <el-select
            v-model="searchCondition.brandId"
            filterable
            placeholder="请选择商品品牌"
            size="small"
            clearable
            class="mr10"
            @change="search1"
        >
          <el-option
              :label="v.brandName"
              :value="v.brandId"
              v-for="(v, i) in allBrandList.records"
              :key="i"
          >
          </el-option>
        </el-select>
        <el-input
            clearable
            style="width: 300px"
            v-model.trim="searchCondition.keyWords"
            placeholder="请输入商品货号/关键词"
            size="small"
            class="ipt mr10 mb10"
        ></el-input>
        <el-button size="small" type="primary" @click="search1">查询</el-button>
      </div>
      <div class="btn-wrapper2 flex flex-end item-center mt10">
        <div class="flex flex-center item-center mul-delete" @click="mulDelete">
          <span class="hmicon icon-shanchu1"></span>
          <span>批量删除</span>
        </div>
      </div>
      <div class="mt20">
        <el-table
            stripe
            border
            :data="relGoodsList"
            style="width: 100%"
            ref="relGoodsList"
        >
          <el-table-column
              type="selection"
              width="50"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="(index) => index + (currentPage1 - 1) * pageSize1 + 1"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="wxshopSpuName"
              label="商品名称"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="goodsSn"
              label="商品货号"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="brandName"
              label="品牌"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              label="排序"
              prop="seqNum"
          >
            <template slot-scope="scope">
              <div @dblclick="changeEnddate1(scope.$index, scope.row)">
                <el-tooltip
                    class="item"
                    effect="dark"
                    content="双击修改"
                    placement="top"
                    :disabled="scope.row.edit_enddate"
                >
                <span v-show="scope.row.edit_enddate" class="blue">{{
                    scope.row.seqNum
                  }}</span>
                </el-tooltip>
                <el-input
                    type="number"
                    :ref="'enddateinput' + scope.$index"
                    @blur="enddateblur1(scope.$index, scope.row)"
                    @keyup.enter.native="$event.target.blur"
                    clearable
                    v-show="!scope.row.edit_enddate"
                    size="mini"
                    style="width: 100%"
                    v-model="scope.row.seqNum"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="wxshopNickName"
              label="简称"
          >
          <template slot-scope="scope">
              <div @dblclick="changeEnddate2(scope.$index, scope.row)">
                <el-tooltip
                    class="item"
                    effect="dark"
                    content="双击修改"
                    placement="top"
                    :disabled="scope.row.edit_wxshopNickName"
                >
                <span v-show="scope.row.edit_wxshopNickName" class="blue">{{
                    scope.row.wxshopNickName
                  }}</span>
                </el-tooltip>
                <el-input
                    type="text"
                    :ref="'enddateinput2' + scope.$index"
                    @blur="enddateblur2(scope.$index, scope.row)"
                    @keyup.enter.native="$event.target.blur"
                    clearable
                    v-show="!scope.row.edit_wxshopNickName"
                    size="mini"
                    style="width: 100%"
                    maxLength="20"
                    v-model="scope.row.wxshopNickName"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              label="操作"
              v-if="radioType === 'manage'"
          >
            <template slot-scope="scope">
              <el-button
                  @click="singleDelete(scope.row)"
                  size="small"
                  class="danger"
                  type="text"
              >移除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="goodsListTotal1"
            @current-change="paging1"
            @size-change="handleSizeChange1"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage1"
        ></el-pagination>
      </div>
      <div class="btn-wrapper flex flex-center mt20">
        <el-button
            size="small"
            type="primary"
            @click="operateDialogVisible = false"
        >确定</el-button
        >
        <el-button
            size="small"
            type="info"
            @click="operateDialogVisible = false"
        >取消</el-button
        >
      </div>
    </el-dialog>
    <!-- 添加商品弹窗 -->
    <el-dialog
        width="1200px"
        title="请选择微店商品"
        :visible="addGoodsDialogVisible"
        @close="addGoodsDialogVisible = false"
    >
      <div class="top-btn-wrapper flex flex-end">
        <el-select
            v-model="searchCondition2.spuType"
            filterable
            placeholder="请选择微店商品分类"
            size="small"
            clearable
            class="mr10"
            @change="search2"
        >
          <el-option label="实物" value="reality"></el-option>
          <el-option label="虚拟" value="virtual"></el-option>
        </el-select>
        <el-select
            v-model="searchCondition2.brandId"
            filterable
            placeholder="请选择商品品牌"
            size="small"
            clearable
            class="mr10"
            @change="search2"
        >
          <el-option
              :label="v.brandName"
              :value="v.brandId"
              v-for="(v, i) in allBrandList.records"
              :key="i"
          ></el-option>
        </el-select>
        <el-input
            clearable
            style="width: 300px"
            v-model.trim="searchCondition2.keyWords"
            placeholder="请输入商品货号/关键词"
            size="small"
            class="ipt mr10 mb10"
        ></el-input>
        <el-button size="small" type="primary" @click="search2">查询</el-button>
      </div>
      <div class="mt20">
        <el-table
            stripe
            border
            :data="goodsList"
            style="width: 100%"
            ref="goodsTable"
        >
          <el-table-column
              type="selection"
              width="50"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="(index) => index + (currentPage2 - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="wxshopSpuName"
              label="商品名称"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="wxshopNickName"
              label="简称"
              width="160"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="goodsSn"
              label="商品货号"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="brandName"
              label="品牌"
          >
          </el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            label="操作"
            v-if="radioType === 'manage'"
          >
            <template slot-scope="scope">
              <el-button
                @click="deleteGoods(scope.row)"
                size="small"
                class="danger"
                type="text"
                >移除</el-button
              >
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="goodsListTotal2"
            @current-change="paging2"
            @size-change="handleSizeChange2"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage2"
        ></el-pagination>
      </div>
      <div class="btn-wrapper flex flex-center mt20">
        <el-button size="small" type="primary" @click="goodsConfirm(radioType)"
        >确定</el-button
        >
        <el-button
            size="small"
            type="info"
            @click="addGoodsDialogVisible = false"
        >取消</el-button
        >
      </div>
    </el-dialog>
    <!-- 导入商品失败弹窗 -->
    <el-dialog
        append-to-body
        :visible.sync="errValidGoods"
        @close="errValidGoods = false"
        width="500px"
        title="提示"
    >
      <div>
        <div class="mb20 err-valid-goods-tips">
          以下商品导入失败(<span style="color: #ef8536"
        >失败原因：商品信息在微店未找到或者同一商品多个关联码</span
        >)
        </div>
        <el-table :data="errInputResult" border class="small-table">
          <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
          ></el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="specBarcode"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="wxshopSpuName"
            label="商品货号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="品牌"
          ></el-table-column> -->
          <el-table-column
              header-align="center"
              align="center"
              prop="goodsSn"
              label="货号"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="relationCode"
              label="关联编码"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="relationName"
              label="关联名称"
          ></el-table-column>
        </el-table>
        <div class="flex flex-center item-center mt20">
          <el-button size="small" type="primary" @click="importErr"
          >知道了</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
import { arrayUnique2 } from "@/utils/utils";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  name: "storeFinanceDayStatInfo",
  data() {
    return {
      drawer: false,
      isOutputing: false,
      // 导入失败弹窗
      errValidGoods: false,
      errInputResult: "",
      total: 0,
      settleState_options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "otherShop",
          label: "跨店取货",
        },
        {
          value: "currentShop",
          label: "本店取货",
        },
      ],
      takeStatus_options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "success",
          label: "跨店调拨已完成",
        },
        {
          value: "fail",
          label: "跨店调拨未完成",
        },
      ],
      state_options: [
        {
          value: "otherShop",
          label: "跨店取货",
        },
        {
          value: "currentShop",
          label: "本店取货",
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      searchCondition: {
        settleState: "",
        dateValue: "",
        // radioType: "manage",
      },
      searchCondition2: {
        settleState: "",
        dateValue: "",
      },
      tableData: [],
      tableData2: [],
      // 关联码列表分页
      pageSize: 10,
      currentPage: 1,
      // 商品管理分页
      currentPage1: 1,
      pageSize1: 10,
      // 添加商品分页
      pageSize2: 10,
      currentPage2: 1,
      dialogVisible: false,
      // 微店商品表格
      // goodsList:[],
      // 添加商品
      goodsList: [],
      goodsListTotal: 0,
      goodsListTotal1: 0,
      goodsListTotal2: 0,
      // 关联码里面的商品列表
      relGoodsList: [],
      // 当前行的relationId
      rowRelId: "",
      radioType: "manage",
      // 关联商品详情表单
      ruleForm: {
        relationCode: "",
        relationName: "",
      },
      rules: {
        relationCode: {
          required: true,
          message: "请输入关联码",
          trigger: "change",
        },
        relationName: {
          required: false,
          message: "请输入关联组名称",
          trigger: "change",
        },
      },
      // 商品操作弹窗
      operateDialogVisible: false,
      // 添加商品弹窗
      addGoodsDialogVisible: false,
      allBrandList: [],
      editSortNum: "",
      relName: ""
    };
  },
  created() {
    this.queryList();
    this.queryBrandAllList();

    setTimeout(() => {
      // this.tableData = "";
      // this.errValidGoods = true;
      // 获取商品品牌数据
      // this.queryBrandAllList();
    }, 3000);
  },
  methods: {
    changeEnddate(index, rowdata) {
      // this.editSortNum = rowdata.seqNum;
      this.tableData2[index].edit_enddate = false;
      this.tableData2 = [...this.tableData2];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs["enddateinput" + index].focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    enddateblur(index, rowdata) {
      // rowdata.seqNum = rowdata.editSortNum;
      this.tableData2 = [...this.tableData2];
      this.tableData2[index].edit_enddate = true
    },
    changeEnddate1(index, rowdata) {
      this.relGoodsList[index].edit_enddate = false;
      this.relGoodsList = [...this.relGoodsList];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs["enddateinput" + index].focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    enddateblur1(index, rowdata) {
      this.relGoodsList = [...this.relGoodsList];
      this.relGoodsList[index].edit_enddate = true;
      if (this.rowRelId && rowdata.seqNum) {
        let params = {
          relationId: this.rowRelId,
          wxshopSpuId: rowdata.wxshopSpuId,
          seqNum: rowdata.seqNum
        }
        this.$store.dispatch(
            "updateSeqNum",
            params
        )
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    // 查询商品
    //
    // 列表
    async queryBrandAllList() {
      const { result } = await this.$store.dispatch("queryBrandAllList", {
        pageSize: 999999,
        pageNo: 1,
      });
      this.allBrandList = result;
      console.log("allBrandList");
      console.log(this.allBrandList);
    },
    // 弹窗:商品操作分页
    paging1(page) {
      this.currentPage1 = page;
      this.queryRelWxshopSpuInfoPageListByRelationId(this.rowRelId);
    },
    handleSizeChange1(size) {
      this.currentPage1 = 1;
      this.pageSize1 = size;
      this.queryRelWxshopSpuInfoPageListByRelationId(this.rowRelId);
    },
    search1() {
      this.currentPage1 = 1;
      this.queryRelWxshopSpuInfoPageListByRelationId(this.rowRelId);
    },
    // 弹窗添加商品表格翻页
    paging2(page) {
      this.currentPage2 = page;
      this.queryList2();
    },
    handleSizeChange2(size) {
      this.currentPage2 = 1;
      this.pageSize = size;
      this.queryList2();
    },
    search2() {
      this.currentPage2 = 1;
      this.queryList2();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    switchTab(val) {
      console.log(val);
      // 切换清空弹窗表格内容
      this.goodsList = [];
      if (val == "manage") {
        this.queryList();
      }
      // this.currentPage = 1;
      // this.queryList();
    },
    // 添加商品的确定按钮
    async goodsConfirm() {
      const selectData = this.$refs.goodsTable.selection;
      if (this.radioType === "manage") {
        // 追加商品到选中的关联组
        console.log("追加商品");
        this.wxshopSpuRelationRelAdd(selectData);
      } else {
        // 添加选中数据到关联商品详情页面table2
        // const selectData = this.$refs.goodsTable.selection;
        // this.tableData2 = selectData;
        // console.log(selectData);
        this.tableData2 = this.tableData2.concat(selectData);
        // 添加去重
        this.tableData2 = arrayUnique2(this.tableData2, "wxshopSpuId");
        this.tableData2.forEach(dv=>{
          dv.seqNum = 99;
          dv.edit_enddate = true;
          if(!dv.wxshopNickName){
            dv.wxshopNickName = "";
          }
          dv.edit_enddate = true;
          if(dv.wxshopNickName){
            dv.edit_wxshopNickName = true;
          }else{
            dv.edit_wxshopNickName = false;
          }
        })
        this.tableData2 = JSON.parse(JSON.stringify(this.tableData2));
        console.log("this.tableData2:",this.tableData2);
      }
      this.addGoodsDialogVisible = false;
    },
    async wxshopSpuRelationRelAdd(selectData) {
      const { storeCode } = getLoginUser();
      let params = {
        relationId: this.rowRelId,
        addWxshppSpuIds: selectData,
        storeCode: storeCode,
      };
      const { code, result } = await this.$store.dispatch(
          "wxshopSpuRelationRelAdd",
          params
      );
      if (code == "0") {
        this.$message({
          message: "添加成功!",
          type: "success",
        });
      }
      // 刷新微店商品管理列表
      this.queryRelWxshopSpuInfoPageListByRelationId(this.rowRelId);
    },
    // 获取关联码列表
    async queryList() {
      const { storeCode } = getLoginUser();
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        storeCode: storeCode,
        relationName: this.relName
      };
      // const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // if (this.isArray(searchCondition.dateValue)) {
      //   searchCondition.beginDate =
      //     searchCondition.dateValue && searchCondition.dateValue.length > 0
      //       ? searchCondition.dateValue[0] + " 00:00:00"
      //       : "";
      //   searchCondition.endDate =
      //     searchCondition.dateValue && searchCondition.dateValue.length > 0
      //       ? searchCondition.dateValue[1] + " 23:59:59"
      //       : "";
      // }
      // Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
          "wxshopSpuRelationInfo",
          params
      );
      const { records, total } = result;
      this.tableData = records;
      this.total = total;
    },
    // 1-追加商品,2-添加商品
    addGoods() {
      console.log(this.radioType);
      // 切换清空弹窗表格内容
      this.goodsList = [];
      this.searchCondition2 = {};
      // 如果是第一个标签页,追加商品
      // 如果是第二个,添加商品后,渲染到第二个页面表格上
      this.addGoodsDialogVisible = true;
      // 初始化pagesize
      this.currentPage2 = 1;
      this.queryList2();
      // if (this.radioType == "manage") {

      // } else {
      //   this.addGoodsDialogVisible = true;
      //   this.queryList2();
      // }
    },
    // 关联商品详情-表格2的列表单行删除
    table2RowDel(index) {
      this.tableData2.splice(index, 1);
    },
    // 商品关联编码和商品信息同时保存接口
    async relCreate() {
      const { storeCode } = getLoginUser();
      console.log('this.ruleForm.relationCode',this.ruleForm.relationCode)
      if(!this.ruleForm.relationCode){
        this.$message({
          message: "请输入关联码",
          type: "warning",
        });
        return
      }
      let params = {
        relationCode: this.ruleForm.relationCode,
        relationName: this.ruleForm.relationName,
        relModelList: this.tableData2,
        storeCode: storeCode,
      };
      const { code, result } = await this.$store.dispatch(
          "wxshopSpuRelationInfoAddAll",
          params
      ).catch(res=>{
        console.log("保存失败");
        // this.$message({
        //   message: result,
        //   type: "warning",
        // });
        this.errValidGoods = true;
        this.errInputResult = res.result;
      });
      if (code == "0") {
        // this.$api.msg = result || "保存成功!"
        this.$message({
          message: "保存成功!",
          type: "success",
        });
        this.ruleForm.relationCode = "";
        this.ruleForm.relationName = "";
        this.tableData2 = [];
        // 跳转到关联商品管理
        this.radioType = 'manage'
        this.queryList()
      }
      console.log(result);
    },
    // 通用-查询微店列表
    async queryList2() {
      const { storeCode } = getLoginUser();
      let params = {
        pageNo: this.currentPage2,
        pageSize: this.pageSize,
        storeCode: storeCode,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition2));
      if (this.isArray(searchCondition.dateValue)) {
        searchCondition.beginDate =
            searchCondition.dateValue && searchCondition.dateValue.length > 0
                ? searchCondition.dateValue[0] + " 00:00:00"
                : "";
        searchCondition.endDate =
            searchCondition.dateValue && searchCondition.dateValue.length > 0
                ? searchCondition.dateValue[1] + " 23:59:59"
                : "";
      }
      Object.assign(params, searchCondition);
      // 这里要修改接口
      console.log("type", this.radioType);
      let queryName = "notUsedGoods";
      const { result } = await this.$store.dispatch(queryName, params);
      const { records, total } = result;
      this.goodsList = records;
      this.goodsListTotal2 = total;
    },
    async errMsg(scope) {
      let params = JSON.parse(JSON.stringify(scope.row));
      console.log(params);
      this.$alert(params.errorInfo, "异常原因", {
        confirmButtonText: "确定",
        // callback: action => {
        //   this.$message({
        //     type: 'info',
        //     message: `action: ${ action }`
        //   });
        // }
      });
    },
    // 商品管理-商品操作
    edit(row, index) {
      // 切换清空弹窗表格内容
      this.relGoodsList = [];
      this.searchCondition = {};
      this.operateDialogVisible = true;
      this.rowRelId = row.id;
      this.queryRelWxshopSpuInfoPageListByRelationId(this.rowRelId);
    },
    // 商品管理-操作列表
    async queryRelWxshopSpuInfoPageListByRelationId(relationId) {
      // 根据商品id查询
      let params = {
        relationId,
        pageNo: this.currentPage1,
        pageSize: this.pageSize1,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (this.isArray(searchCondition.dateValue)) {
        searchCondition.beginDate =
            searchCondition.dateValue && searchCondition.dateValue.length > 0
                ? searchCondition.dateValue[0] + " 00:00:00"
                : "";
        searchCondition.endDate =
            searchCondition.dateValue && searchCondition.dateValue.length > 0
                ? searchCondition.dateValue[1] + " 23:59:59"
                : "";
      }
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
          "queryRelWxshopSpuInfoPageListByRelationId",
          params
      );
      const { records, total } = result;
      console.log(result);
      this.relGoodsList = records;
      this.goodsListTotal1 = total;
      if (this.relGoodsList) {
        this.relGoodsList.forEach(dv=>{
          if(!dv.wxshopNickName){
            dv.wxshopNickName = "";
          }
          dv.edit_enddate = true;
          if(dv.wxshopNickName){
            dv.edit_wxshopNickName = true;
          }else{
            dv.edit_wxshopNickName = false;
          }
        })
        this.relGoodsList = JSON.parse(JSON.stringify(this.relGoodsList));
        console.log("this.relGoodsList:",this.relGoodsList);
      }
    },
    // 商品管理-单个删除
    async singleDelete(row) {
      this.$confirm("是否确认将该商品移除关联组？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            console.log("全部商品移除关联组");
            // console.log(row)
            this.wxshopSpuRelationRelDelete(row.id);
          })
          .catch(() => {
            // this.$message({
            //   type: "info",
            //   message: "已取消全部商品移除关联组",
            // });
          });
    },
    // 商品管理-批量删除
    async mulDelete() {
      const selectData = this.$refs.relGoodsList.selection;
      console.log("del selectData");
      console.log(selectData);
      if (selectData.length == 0) {
        this.$message({
          message: "请选择微店商品后删除!",
          type: "warning",
        });
        return;
      }
      this.$confirm("是否确认将全部商品移除关联组？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            console.log("全部商品移除关联组");
            console.log(selectData);
            selectData.forEach((v) => {
              this.wxshopSpuRelationRelMultDelete(v.id);
            });
            setTimeout(() => {
              // 刷新微店商品管理列表
              this.queryRelWxshopSpuInfoPageListByRelationId(this.rowRelId);
            }, 1000);
          })
          .catch(() => {
            // this.$message({
            //   type: "info",
            //   message: "已取消全部商品移除关联组",
            // });
          });
    },
    // 删除接口
    async wxshopSpuRelationRelDelete(rowId) {
      // 根据商品id查询
      let params = {
        id: rowId,
      };
      const { code, result } = await this.$store.dispatch(
          "wxshopSpuRelationRelDelete",
          params
      );
      if (code == "0") {
        this.$message({
          message: "删除成功",
          type: "success",
        });
      } else {
        this.$message({
          message: result,
          type: "warning",
        });
      }
      // 刷新微店商品管理列表
      setTimeout(() => {
        this.queryRelWxshopSpuInfoPageListByRelationId(this.rowRelId);
      }, 1000);
    },
    // 批量删除
    async wxshopSpuRelationRelMultDelete(rowId) {
      // 根据商品id查询
      let params = {
        id: rowId,
      };
      const { code, result } = await this.$store.dispatch(
          "wxshopSpuRelationRelDelete",
          params
      );
    },
    // 商品管理-移除关联码
    deleteAgent(row) {
      console.log(row);
      this.$confirm("此操作将删除关联码及关联的商品信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            console.log("执行删除");
            this.queryDeleteManageRow(row);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
    async queryDeleteManageRow(row) {
      // 根据商品id查询
      let params = {
        id: row.id,
      };
      const { code, result } = await this.$store.dispatch(
          "wxshopSpuRelationInfoDelete",
          params
      );
      if (code == "0") {
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: result,
          type: "warning",
        });
      }
      // 刷新列表
      this.queryList();
    },
    // 多选
    // getGoodsChecked(value) {
    //   console.log(value);
    // },
    // 关联商品详情-取消
    addCancel() {
      this.radioType = "manage";
      this.queryList();
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["货号", "关联编码", "关联名称"];
        const data = [];

        exportJsonToExcel(tHeader, data, "导入关联组模板");
      });
    },
    // 导入数据
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        const goodsSnList = [];
        result.forEach((v) => {
          goodsSnList.push({
            goodsSn: v[0],
            relationCode: v[1],
            relationName: v[2],
          });
        });
        // let params = {
        //   pageSize: 99999,
        //   pageNo: 1,
        //   goodsSnList,
        // };
        let params = goodsSnList;

        that.$store
            .dispatch("queryWxshopSpuRelationRelImportData", params)
            .then((res) => {
              const { code, result } = res;
              if (code === "0") {
                that.$message({
                  message: "导入成功!",
                  type: "success",
                });
                that.queryList()
              } else {
                // 失败弹窗表格
                // this.errValidGoods = true;
                // this.errInputResult = result;
                // console.log("222233333");
                // that.$message({
                //   message: errMsg,
                //   type: "warning",
                // });
              }
            })
            .catch((res) => {
              const { code, result, errMsg } = res;
              if (code === "-1") {
                that.errValidGoods = true;
                that.errInputResult = result;
              }
            });

        // if (isValid && isRequired) {
        //   that.rightData = formatResult;
        //   // that.memberCount = formatResult.length;
        // } else {
        //   if (!isRequired) {
        //     that.$message({
        //       message: "导入失败，请导入完整商品信息！",
        //       type: "warning"
        //     });
        //   } else if (!isValid) {
        //     that.$message({
        //       message: "导入失败，日期请使用文本格式导入！",
        //       type: "warning"
        //     });
        //   }
        // }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    // 导入失败确定刷新
    importErr(){
      this.errValidGoods = false
      this.queryList()
    },
    // output() {
    //   require.ensure([], () => {
    //     const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
    //     this.isOutputing = true;
    //     const { storeCode } = getLoginUser();
    //     let params = {
    //       pageNo: this.currentPage,
    //       pageSize: 9999999,
    //       storeCode: storeCode,
    //     };
    //     const searchCondition = JSON.parse(
    //       JSON.stringify(this.searchCondition)
    //     );
    //     if (this.isArray(searchCondition.dateValue)) {
    //       searchCondition.beginDate =
    //         searchCondition.dateValue && searchCondition.dateValue.length > 0
    //           ? searchCondition.dateValue[0] + " 00:00:00"
    //           : "";
    //       searchCondition.endDate =
    //         searchCondition.dateValue && searchCondition.dateValue.length > 0
    //           ? searchCondition.dateValue[1] + " 23:59:59"
    //           : "";
    //     }
    //     Object.assign(params, searchCondition);
    //     this.$store
    //       .dispatch("queryGoodsDetailsPageList", params)
    //       .then((res) => {
    //         // const list = this.activityCenterAllList.records;
    //         console.log(res);
    //         const list = res.result.records;
    //         list.forEach((v) => {
    //           if (v.takeType == "otherShop") {
    //             v.takeType = "跨店取货";
    //           } else {
    //             v.takeType = "本店取货";
    //           }
    //           if (v.takeStatus == "success") {
    //             v.takeStatus = "成功";
    //             v.errorInfo = "";
    //           } else {
    //             v.takeStatus = "失败";
    //           }
    //           v.goodsSize = v.goodsSize + " " + v.goodsColor;
    //         });
    //         console.log(list);
    //         const tHeader = [
    //           "取货单号",
    //           "跨店调拨状态",
    //           "商品名称",
    //           "货号",
    //           "规格",
    //           "取货门店",
    //           "寄存门店",
    //           "取货数量",
    //           "取货类型",
    //           "取货经手人",
    //           "取货时间",
    //           "取货会员",
    //           "异常原因",
    //         ];
    //         const filterVal = [
    //           "batchSeq",
    //           "takeStatus",
    //           "goodsName",
    //           "goodsSn",
    //           "goodsSize",
    //           "takeOrgName",
    //           "depositOrgName",
    //           "takeNum",
    //           "takeType",
    //           "createBy",
    //           "createTime",
    //           "memberName",
    //           "errorInfo",
    //         ];
    //         const data = this.formatJson(filterVal, list);
    //         console.log(data);
    //         exportJsonToExcel(
    //           tHeader,
    //           data,
    //           "寄存取货流水" + new Date().toLocaleString()
    //         );
    //         this.isOutputing = false;
    //       })
    //       .catch(() => {
    //         this.isOutputing = false;
    //       });
    //   });
    // },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },    
    changeEnddate3(index, rowdata) {
      console.log("changeEnddate3双击")
      this.tableData2[index].edit_wxshopNickName = false;
      this.tableData2 = [...this.tableData2];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs["enddateinput3" + index].focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    async enddateblur3(index, rowdata) {
      this.tableData2 = [...this.tableData2];
      if(!rowdata.wxshopNickName){
        this.tableData2[index].edit_wxshopNickName = false;
        // return;
      }else{
        this.tableData2[index].edit_wxshopNickName = true;
      }
      console.log("修改成功")
      if (rowdata.wxshopSpuId) {
        let params = {
          wxshopSpuId: rowdata.wxshopSpuId,
          wxshopNickName: rowdata.wxshopNickName
        }
        const { code, result } = await this.$store.dispatch(
            "editWxshopSpuNickName",
            params
        )
        if (code == "0") {
          this.$message({
            message: result,
            type: "success",
          });
        }        
      }
    },


    changeEnddate2(index, rowdata) {
      this.relGoodsList[index].edit_wxshopNickName = false;
      this.relGoodsList = [...this.relGoodsList];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs["enddateinput2" + index].focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    async enddateblur2(index, rowdata) {
      this.relGoodsList = [...this.relGoodsList];
      if(!rowdata.wxshopNickName){
        this.relGoodsList[index].edit_wxshopNickName = false;
        // return;
      }else{
        this.relGoodsList[index].edit_wxshopNickName = true;
      }
      console.log("修改成功")
      if (rowdata.wxshopSpuId) {
        let params = {
          wxshopSpuId: rowdata.wxshopSpuId,
          wxshopNickName: rowdata.wxshopNickName
        }
        const { code, result } = await this.$store.dispatch(
            "editWxshopSpuNickName",
            params
        )
        if (code == "0") {
          this.$message({
            message: result,
            type: "success",
          });
        }        
      }
    },
  },
};
</script>

<style scoped lang="scss">
.inputDeep >>> .el-input__inner {
  border: 0;
  background: none;
}
.table-panel,
.button-panel {
  margin-bottom: 20px;
}
.add-btn,
.add-goods-btn {
  margin-right: auto;
}
.inputDeep {
  min-height: 550px;
}
.el-table th.el-table__cell.is-leaf {
  color: #222222;
}
.el-table tr {
  background: #f7f7f7;
}
.el-table::before {
  height: 0;
}
.icon-a-zanwushuju2x {
  font-size: 32px;
  margin-bottom: -30px;
}
// 批量删除
.icon-shanchu1 {
  font-size: 24px;
}
.mul-delete {
  cursor: pointer;
}
.err-valid-goods-tips {
  font-weight: bold;
}
</style>
